export const QUOTE_DETAILS_SLOTS = {
    AFTER_QUOTE_NOTICE: 'dokan-quote-details-after-notice',
    BEFORE_QUOTE_DETAILS: 'dokan-quote-before-details',
    AFTER_QUOTE_DETAILS: 'dokan-quote-after-details',
    BEFORE_QUOTE_BADGE: 'dokan-quote-details-before-header-badge',
    AFTER_QUOTE_BADGE: 'dokan-quote-details-after-header-badge',
    BEFORE_ACTION_BUTTON: 'dokan-quote-details-after-header-action-button',
    AFTER_ACTION_BUTTON: 'dokan-quote-details-after-header-action-button',
    AFTER_QUOTE_HEADER: 'dokan-quote-details-after-header-info',
    AFTER_QUOTE_CUSTOMER_DETAILS: 'dokan-quote-details-after-customer-details',
    AFTER_PRODUCT_TABLE: 'dokan-quote-details-after-product-info',
    AFTER_SHIPPING_DETAILS: 'dokan-quote-details-after-shipping-info',
    AFTER_ADDITIONAL_MESSAGE: 'dokan-quote-details-after-additional-message',
} as const;
